import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../../../../Theme';

import type { InputThemeProps } from '../../../utils/themes';

/**
 * Import Themes
 */

import inputLabelInBlogTheme from './_blog';
import inputLabelInSiteTheme from './_site';

/**
 * Group Themes
 */

const inputLabelInThemes = (labelInThemeProps: Pick<InputThemeProps, 'inputType' | 'inputVariant'>) =>
  new MatchedMap([
    [ThemeEnum.Blog, inputLabelInBlogTheme(labelInThemeProps)],
    [ThemeEnum.Site, inputLabelInSiteTheme(labelInThemeProps)],
  ]);

/**
 * Theme Hook
 */

const useInputLabelInTheme = (labelInThemeProps: Pick<InputThemeProps, 'inputType' | 'inputVariant'>) =>
  useTheme({}, inputLabelInThemes(labelInThemeProps));

export default useInputLabelInTheme;
